import { Amplify } from "aws-amplify";
import { amplifyConfig } from "../config/environment";

// Merge environment config with additional Auth configuration
const completeAmplifyConfig = {
  ...amplifyConfig,
  Auth: {
    Cognito: {
      userPoolId: "us-east-2_tuG0KYG39",
      userPoolClientId: "36sks9qhu7ncvt4f476mmbceo8",
      signUpVerificationMethod: "code" as const,
      loginWith: {
        email: true,
        username: false,
        phone: false,
      },
    },
  },
  OAuth: {
    domain: "standardleague-auth-702.auth.us-east-2.amazoncognito.com",
    scope: ["email", "openid", "profile"],
    redirectSignIn: "http://localhost:3000/oauth/callback",
    redirectSignOut: "http://localhost:3000/",
    responseType: "code",
    clientId: "36sks9qhu7ncvt4f476mmbceo8",
  },
};

// Configure Amplify with the complete configuration
Amplify.configure(completeAmplifyConfig);

export default Amplify;
